<div class="alphanumeric-keypad grid-container">
  <div
    class="row horizontal-ac grid-container-row"
    *ngFor="let row of keys; let i = index; trackBy: trackByIndex"
    [class.is-last-row]="i === keys.length - 1"
  >
    <button
      *ngFor="let key of row; let j = index; trackBy: trackByIndex"
      class="key focusable-element"
      [class.is-last-key]="j === row.length - 1"
      [class.backspace]="key === 'BACK'"
      [class.wide]="key === 'SPACE' || key === 'CLEAR'"
      [style]="((key === 'SPACE' || key === 'CLEAR') ? 'fontSize.24' : 'fontSize.28') | translate"
      [class.space]="key === 'SPACE'"
      [class.clear]="key === 'CLEAR'"
      (click)="onKeyClick(key)"
      (keydown)="onKeyDown($event, i, j)"
      (focus)="setFocus(key)"
    >
      <ng-container *ngIf="key !== 'BACK'; else backspaceIcon">{{
        key
      }}</ng-container>
      <ng-template #backspaceIcon>
        <app-icon [icon]="'search-back'" [isFocused]="isBackFocused"></app-icon>
      </ng-template>
    </button>
  </div>
</div>
